import {useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageUploading from 'react-images-uploading';
import Select from "react-select";
import {countrys,states} from "../../../../../core/common/selectOption";
import {all_routes} from "../../../../router/all_routes";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {Str,Obj,Log,Status_Type} from "biz9-utility";
import {Image_Type,Image_Table,Image_Format,Image_Field,Image_Service,Image_Url,Image_Logic} from "biz9-image";
import {User_Url,User_Field,User_Table,User_Service} from "biz9-user";
import {Data_Logic} from "biz9-data-app";
import {Field,Message,Title,Type,Url} from "../../../../../constant";
 import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Portal_Table,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Image,Portal_Remote_User} from "biz9-portal-app";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../../../project";
/* -- biz9 import end -- */
const BuyerSettings = () => {
    const alert_prop = useRef(null);
	const navigate = useNavigate();
    const [user,setUser] = useState(User.get());
    const [val_username,setValUserName] = useState(user.username);
    const [val_first_name,setValFirstName] = useState(user.first_name);
    const [val_last_name,setValLastName] = useState(user.last_name);
    const [val_email,setValEmail] = useState(user.email);
    const [val_new_email,setValNewEmail] = useState("");
    const [val_confirm_email,setValConfirmEmail] = useState("");
    const [val_password,setValPassword] = useState(user.password);
    const [val_new_password,setValNewPassword] = useState("");
    const [val_confirm_password,setValConfirmPassword] = useState("");
    const [val_country, setValCountry] = useState(null);
    const [val_state,setValState] = useState(null);
    const [val_city,setValCity] = useState(user.city);
    const [val_gender, setValGender] = useState(user.gender);
	const [hide_btn_image_post,setHideBtnImagePost] = useState(false);
    const [images,setImages] = useState([]);
	const image_list_max_count = 1;
    const [image_primary,setImagePrimary] = useState([]);
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        if(user){
            get_data(user);
        }
    },[]);
    async function get_data(item) {
        bind_field(item);
        Toast_Message.dismiss();
	}
    async function bind_field(item) {
        setValCountry(countrys.find(option => option.value === item.country));
        setValState(states.find(option => option.value === item.state));
        if(item.image_filename){
			setImagePrimary([{image_filename:item.image_filename}]);
			setHideBtnImagePost(true);
		}
    };
    const handle_submit = (event) => {
        event.preventDefault();
    };
    const updateValFirstName = (event) => {
        setValFirstName(event.target.value);
    };
    const updateValLastName = (event) => {
        setValLastName(event.target.value);
    };
    const updateValEmail = (event) => {
        setValEmail(event.target.value);
    };
    const updateValNewEmail = (event) => {
        setValNewEmail(event.target.value);
    };
    const updateValConfirmEmail = (event) => {
        setValConfirmEmail(event.target.value);
    };
    const updateValPassword = (event) => {
        setValPassword(event.target.value);
    };
    const updateValNewPassword = (event) => {
        setValNewPassword(event.target.value);
    };
    const updateValConfirmPassword = (event) => {
        setValConfirmPassword(event.target.value);
    };
    const updateValCity = (event) => {
        setValCity(event.target.value);
        post_field(User_Field.CITY,event.target.value,{});
    };
    const updateValCountry = (selectedOption) => {
        setValCountry(selectedOption);
        post_field(User_Field.COUNTRY,selectedOption.value,{});
    };
    const updateValState = (selectedOption) => {
        setValState(selectedOption);
        post_field(User_Field.STATE,selectedOption.value,{});
    };
    const updateValGender = (event) => {
        setValGender(event.target.value);
        post_field(User_Field.GENDER,event.target.value,{});
    };
    const updateValUserName = (event) => {
        setValUserName(event.target.value);
    };
    async function bind_image(item) {
        if(item.images.length>0){
            setImages(item.images);
        }
    };
    async function onImagePrimaryChange(image_upload, addUpdateIndex){
        Toast_Message.loading(Message.SAVING);
        setHideBtnImagePost(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(response.status == Status_Type.SUCCESS){
            Toast_Message.success(response.message);
            setHideBtnImagePost(true);
            post_field(Image_Field.IMAGE_FILENAME,data[0].image_filename,{});
            setImagePrimary([data[0]]);
        }else{
            Toast_Message.error(response.message);
            setHideBtnImagePost(false);
        }
        Toast_Message.dismiss();
    };
    const onImagePrimaryDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            Toast_Message.loading(Message.DELETING);
            setHideBtnImagePost(false);
            setImagePrimary([]);
            post_field(User_Field.IMAGE_FILENAME,'',{success_message:Message.DELETED});
        };
    };
    //9_post_field
    async function post_field(field,value,option){
        let valid_form = true;
        if(!value){
            value = '';
        }
        //password
        if(field == User_Field.PASSWORD){
            if(val_confirm_password != value){
                valid_form = false;
                Toast_Message.error(Message.USER_PASSWORD_NEW_CONFIRM_BAD);
            }else if(!Str.check_is_true(Str.validate_password(value))){
                valid_form = false;
                Toast_Message.error(Str.validate_password(value));
            }else{
                setValPassword(value);
            }
        }
        if(valid_form){
            Toast_Message.loading(Message.SAVING);
            user[field] = value;
            let [response,data] = await Portal_Remote_User.post(App.get_url(Portal_Url.USER_POST),user);
            Log.w('44_post_user',user);
            if(response.status == Status_Type.SUCCESS){
                setUser(data);
                User.post(data);
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(response.message);
            }
        }
    };
     return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>Settings</h4>
            </div>
            <div className="settings-info bg-white rounded-2">
            <div className="tab-content">
            {/* Profile Settings */}
            <div
            className="tab-pane fade show active"
            id="Personal_Information"
            role="tabpanel"
            >
<Link to={all_routes.dashboard_user_profile_detail}  className="nav-link" >
{"<- Back"}
</Link>
            <br/>
            <div className="settings-card">
            <div className="settings-card-head bg-light">
            <h4>Personal Information</h4>
            </div>
            <form onSubmit={handle_submit}>

            <div className="settings-card-body">
            <div className="img-upload-head">
            <div className="img-formate">
            <div className="upload-remove-btns">

            <div className="form-wrap">
<ImageUploading
value={image_primary}
onChange={onImagePrimaryChange}
maxNumber={image_list_max_count}
dataURLKey={Image_Field.BASE64}>
{({
		imageList,
		onImageUpload,
		onImageRemoveAll,
		onImageUpdate,
		isDragging,
		dragProps,
		}) => (
			<div className="upload__image-wrapper">
			<button hidden={hide_btn_image_post} className="btn btn-secondary mb-2"
			style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
			{...dragProps} >
			Image
			</button>
			&nbsp;
			{imageList.map((image, index) => (
						<div key={index} className="image-item">
						<img src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
						<div className="image-item__btn-wrapper">
						<Link onClick={() => onImagePrimaryDelete() } to="#" className="mb-2" >
						<FeatherIcon icon="trash-2" />
						</Link>
						</div>
						</div>
						))}
			</div>
			)}
		</ImageUploading>
	   </div>
        </div>
        </div>
        </div>
        <div className="row">
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label">
        {" "}
    UserName{" "}
    <span className="text-primary">*</span>
        </label>
        <input  onChange={updateValUserName} value={val_username} type="text" className="form-control" onBlur={() => post_field(User_Field.USERNAME,val_username,{required:true})} />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap gig-option">
        <label className="mb-1 fw-medium text-dark d-block mb-2">
        {" "}
    Gender <span className="text-primary">*</span>
        </label>
        <label className="custom_radio">
        <input
        type="radio"
        name="gender"
        value="Male"
        checked={val_gender === 'Male'}
    onChange={updateValGender}
    />

        <span className="checkmark" />
        Male
        </label>
        <label className="custom_radio">

        <input
        type="radio"
        name="gender"
        value="Female"
        checked={val_gender === 'Female'}
    onChange={updateValGender}
    />

        <span className="checkmark" />
        Female
        </label>
        </div>
        </div>

        </div>
        <div className="row">
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label">
        {" "}
    First Name{" "}
        </label>
        <input value={val_first_name} onChange={updateValFirstName} type="text" className="form-control" onBlur={() => post_field(User_Field.FIRST_NAME,val_first_name,{})} />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label">
        {" "}
    Last Name{" "}
        </label>
        <input  value={val_last_name} onChange={updateValLastName} type="text" className="form-control" onBlur={() => post_field(User_Field.LAST_NAME,val_last_name,{})} />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        City
        </label>
        <input  value={val_city} onChange={updateValCity} type="text" className="form-control" onBlur={() => post_field(User_Field.CITY,val_city,{})} />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        Country<span className="text-primary">*</span>
        </label>
        <Select
        classNamePrefix="react-select"
        className="select"
        styles={Style.customStyles}
    options={countrys}
    value={val_country}
    onChange={updateValCountry}
    />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        State<span className="text-primary">*</span>
        </label>
        <Select
        classNamePrefix="react-select"
        className="select"
        styles={Style.customStyles}
    options={states}
    value={val_state}
    onChange={updateValState}
    />
        </div>
        </div>

        </div>
        </div>
        </form>
        </div>
        <div className="settings-card">
        <div className="settings-card-head bg-light">
        <h4>Change Email</h4>
        </div>
        <form>
        <div className="settings-card-body">
        <div className="row">
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    Current Email{" "}
        </label>
        <input disabled={true} value={val_email} type="text" className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    New Email{" "}
        </label>
        <input type="text" onChange={updateValNewEmail} value={val_new_email} className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-0">
        <label className="form-label">
        {" "}
    Confirm Email{" "}
        </label>
        <input type="text" onChange={updateValConfirmEmail} value={val_confirm_email} className="form-control" onBlur={() => post_field(User_Field.EMAIL,val_new_email,{})} />
        </div>
        </div>
        </div>
        </div>
        </form>
        </div>


        <div className="settings-card">
        <div className="settings-card-head bg-light">
        <h4>Change Password</h4>
        </div>

        <form>
        <div className="settings-card-body">
        <div className="row">
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    Current Password{" "}
    <span className="text-primary">*</span>
        </label>
        <input disabled={true} value={val_password} type="password" className="form-control" />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-lg-0 mb-md-0">
        <label className="form-label">
        {" "}
    New Password{" "}
        </label>
        <input type="text" onChange={updateValNewPassword} value={val_new_password} className="form-control"  />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap mb-0">
        <label className="form-label">
        {" "}
    Confirm Password{" "}
        </label>
        <input type="text" onChange={updateValConfirmPassword} value={val_confirm_password} className="form-control" onBlur={() => post_field(User_Field.PASSWORD,val_new_password,{})} />
        </div>
        </div>
        </div>
        </div>
        </form>
        </div>
        </div>
        {/* /Profile Settings */}
    </div>
    {/* /Page Content */}
    </div>
        </div>
        </div>
        </div>
        {/* /Page Content */}
    {/* Mouse Cursor */}
    <div className="mouse-cursor cursor-outer" />
        <div className="mouse-cursor cursor-inner" />
        {/* /Mouse Cursor */}
    {/* Top Scroll */}
    <div className="back-to-top">
        </div>

        {/* /Top Scroll */}
    </div>
        </>
        );
};

export default BuyerSettings;
